import { useEffect, useState } from 'preact/hooks';
import { FaMoon, FaSun } from 'react-icons/fa';
import { useClient } from '@/ui/context';
import { getWorldEnvironment, worldPeriod } from '@/world-environment';
import { HUD_TEXT_MUTED } from '@/ui/consts';

/** In the existing HUD row: no floating panel or map input interception. */
export function WorldTimeWidget() {
  const client = useClient();
  const [, tick] = useState(0);
  useEffect(() => { const id = window.setInterval(() => tick(n => n + 1), 1000); return () => window.clearInterval(id); }, []);
  const state = getWorldEnvironment(client);
  if (!state?.enabled) return null;
  const period = worldPeriod(state.game_minute);
  const hour = Math.floor(state.game_minute / 60);
  const minute = Math.floor(state.game_minute % 60);
  const clock = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
  const Icon = period === 'day' ? FaSun : FaMoon;
  return <span class={`pointer-events-none inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-[10px] leading-3 ${HUD_TEXT_MUTED}`} title={`Server time: ${clock}`} aria-label={`${period === 'day' ? 'Day' : 'Night'}, server time ${clock}`}>
    <span aria-hidden='true'><Icon size={12} /></span>{period === 'day' ? 'Day' : 'Night'}
    <span>{clock}</span>
  </span>;
}
